import {ref, type Ref} from "vue";
import axios, {type AxiosResponse} from "axios";
import headers from "../utils/config";
import {type CategoryRequest, CategoryRequestStatus} from "../utils/types";

const OPTIONS = {
    fields: ["address_components", "geometry", "icon", "adr_address"],
    componentRestrictions: {country: ["NZ", "AU"]},
};

export function useGetCategory() {
    const searchInput: Ref<HTMLInputElement | undefined> = ref();
    const responseMessage: Ref<string> = ref("");
    const loading: Ref<boolean> = ref(false);
    const placeNames: Ref<string[]> = ref([]);
    const lat: Ref<number> = ref(0);
    const lng: Ref<number> = ref(0);
    const searchPage: Ref<boolean> = ref(false);
    const searchQuery: Ref<string> = ref("");

    function searchAuto() {
        if (!searchInput.value) return;
        const autocomplete = new google.maps.places.Autocomplete(
            searchInput.value,
            OPTIONS
        );
        autocomplete.addListener("place_changed", () => {
            const places = autocomplete.getPlace();
           
            if (!places.geometry?.location) return;
            lat.value = places.geometry.location.lat();
            lng.value = places.geometry.location.lng();

            searchPage.value = !!(places.address_components?.some(item => item.types.includes('street_number') || item.types.includes('route')))
    
            placeNames.value =
                places.address_components?.map((item) => item.short_name) || [];
            getCategory();
        });
    }

    function setValues(searchAddress: string, names: string[], longitute: number, latitude: number){
        searchQuery.value = searchAddress;
        placeNames.value = names
        lat.value = latitude;
        lng.value = longitute;
        searchPage.value = true
    }

    async function getCategory() {
        try {
           
            responseMessage.value = "";
            loading.value = true;
            const resCat: AxiosResponse<CategoryRequest> = await axios.post(
                "https://www.skyepics.com.au/do/WS/NetoAPI",
                {
                    Filter: {
                        ContentName: placeNames.value,                        
                        OutputSelector: ["ContentURL"],
                        Active: true,
                    },
                },
                {headers}
            );
          
            if (
                resCat.data.Ack === CategoryRequestStatus.SUCCESS &&
                resCat.data.Content?.length
            ) {
                const categoryArray = resCat.data.Content.map(
                    (item) => item.ContentURL
                );

                redirectToCategoryPage(categoryArray);
            } else {
                responseMessage.value = "No images on this location";
            }
        } catch (e) {
            console.log(e);
            responseMessage.value = "";
        } finally {
            loading.value = false;
        }
    }

    function formatSearchString() {     
        const address =  searchInput.value?.value || searchQuery.value
        if (!address) return ''
        const addressString = address.split(",")
        return encodeURI(addressString[0] + "," + addressString[1])
    }

    function redirectToCategoryPage(categories: string[]) {
        const longestUrl = categories
            .map((item) => {
                let count = 0
                placeNames.value.forEach((el) => {
                    if (item.replaceAll("-", " ").includes(el.toLowerCase())) {
                        count++
                    }
                })
                return {
                    url: item,
                    count: count,
                }
            })
            .sort((a, b) => b.count - a.count)
        const searchString = formatSearchString()
       window.location.href = `/${longestUrl[0].url}?searchQuery=${searchString}&lat=${lat.value}&lng=${lng.value}&searchPage=${searchPage.value}`;
    }

    return {
        searchInput,
        searchAuto,
        placeNames,
        responseMessage,
        loading,
        getCategory,
        setValues
    };
}
